module.exports = __webpack_public_path__ + "static/media/signUpIcon.2ccbba4c.svg";